/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled/macro'
import { Checkbox, CheckboxProps, Tooltip } from '@material-ui/core'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import { BRAND_COLOR } from 'lib/constants'
import { Organization } from 'lib/types'
import { isVoiceEnabled } from 'lib/utils/auth'

interface StyledCheckboxProps extends CheckboxProps {
  checkboxcolor: string
}

const Row = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: 10,
})

const Left = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
})

const Text = styled.span({
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: '1.6rem',
})

const StyledCheckbox = styled(Checkbox)<StyledCheckboxProps>(props => ({
  border: '1px solid #FFFFFF',
  padding: '0',
  '&.Mui-checked': {
    color: props.checkboxcolor,
  },
}))

const InfoTrigger = styled.span({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: 0,
  cursor: 'pointer',
  color: 'inherit',
  opacity: 0.8,
  transform: 'translateY(-1px)',
})

const Hint = styled.div({
  marginTop: 6,
  fontSize: 12,
  opacity: 0.8,
  fontFamily: 'Montserrat',
})

export type AssignVoiceLicenseCheckboxProps = {
  org: Organization | null
  checked: boolean
  setChecked: (checked: boolean) => void

  /**
   * TEMP: override gating logic until you wire real checks.
   */
  hasVoiceSetupOverride?: boolean
  licenseAvailableOverride?: boolean
}

export const AssignVoiceLicenseCheckbox = ({
  org,
  checked,
  setChecked,
  hasVoiceSetupOverride,
  licenseAvailableOverride,
}: AssignVoiceLicenseCheckboxProps) => {
  const hasVoiceSetup = typeof hasVoiceSetupOverride === 'boolean' ? hasVoiceSetupOverride : isVoiceEnabled(org)

  // Placeholder until you wire license counts:
  const licenseAvailable = typeof licenseAvailableOverride === 'boolean' ? licenseAvailableOverride : true

  if (!hasVoiceSetup) return null

  const disabled = !licenseAvailable
  const tooltipText = disabled
    ? 'No voice licenses available for this organization.'
    : 'If checked, the new user will be assigned a Voice License.'

  return (
    <div>
      <Row>
        <Left>
          <Text>Assign Voice License</Text>
          {/* 
          <Tooltip title={<span>{tooltipText}</span>} placement="right" arrow>
            <InfoTrigger role="button" tabIndex={0} aria-label="Assign Voice License info">
              <InfoOutlinedIcon fontSize="small" style={{ display: 'block', color: 'inherit' }} />
            </InfoTrigger>
          </Tooltip> */}
        </Left>

        <StyledCheckbox
          checkboxcolor={BRAND_COLOR}
          checked={checked}
          onChange={() => setChecked(!checked)}
          disabled={disabled}
        />
      </Row>

      {disabled && <Hint>Disable another user or reach out to CSM to increase the voice license limit</Hint>}
    </div>
  )
}

export default AssignVoiceLicenseCheckbox
